import api from '../api';

export default class OrientacaoSexualService {
  constructor() {
    throw 'Não é possível instanciar OrientacaoSexualService';
  }

  static async lista() {
    const endpoint = mergeEndpoint();
    console.log(`Orientação Sexual: ${endpoint}`);
    return await api.get(endpoint);
  }
}

const mergeEndpoint = () => {
  return `orientacoes-sexuais`;
};


// WEBPACK FOOTER //
// ./src/services/enums/orientacaoSexualService.js